// 固定页面
const fixedPage = [
    {
        name: 'layout_fixed',
        redirect: {name: 'index'},
        component: () => import('@/layout/index.vue'),
        children: [
            {
                name: 'login',
                path: '/login',
                meta: {
                    title: '登录',
                    requiresAuth: false,
                },
                component: () => import('@/views/public/login.vue'),
            },
            {
                name: 'index',
                path: '/',
                meta: {
                    title: '首页',
                    requiresAuth: true,
                },
                // component: () => import('@/views/dashboard/index.vue'),
                component: () => import('@/views/ai/ai-index.vue'),
            },
        ]
    },
];

// 错误页面
const errorPage = [
    {
        name: '401',
        path: '/401',
        component: () => import('@/views/public/401.vue'),
        meta: {
            title: '401',
        },
    },
    {
        name: '404',
        path: '/:pathMatch(.*)*',
        component: () => import('@/views/public/404.vue'),
        meta: {
            title: '404',
        },
    }
]

// 重新组织后导出
export default [
    ...fixedPage,
    ...errorPage
]